import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '../index.module.scss'

function NotificationsPage(props) {
  return (
    <div className={styles.wrapper} id='notifications'>
      <div className={styles.header}>
        <div className={styles.title}>
          <FormattedMessage id='NOTIFICATIONS' />
        </div>
      </div>
      <div className={styles.body}>
        <p>
          TBA
        </p>
      </div>
    </div>
  )
}

export default NotificationsPage
